var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (model, view) {pug_mixins["showErrors"] = pug_interp = function(errors){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate errors
;(function(){
  var $$obj = errors;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var error = $$obj[pug_index0];
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = error) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var error = $$obj[pug_index0];
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = error) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["datePicker","startDatePicker",model.startDateErrors.length || model.generalErrors.length ? 'error': ''], [false,false,true]), false, true)) + "\u003E\u003Cdiv data-ref=\"startDatePicker\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = view.options.i18n.getString('DateFilter_StartEndDateSeparator')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["datePicker","endDatePicker",model.endDateErrors.length || model.generalErrors.length ? 'error': ''], [false,false,true]), false, true)) + "\u003E\u003Cdiv data-ref=\"endDatePicker\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"errors\"\u003E";
pug_mixins["showErrors"](model.startDateErrors);
pug_mixins["showErrors"](model.endDateErrors);
pug_mixins["showErrors"](model.generalErrors);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return pug_html;};
module.exports = template;